module.exports = __webpack_public_path__ + "img/more-call.2167f812.png";